import { useQuery } from '@tanstack/react-query';
import type { ShelfStatus } from '@booknest/shared';

import { libraryApi } from '../api/library.api.js';

export function useMyShelf(status?: ShelfStatus) {
  return useQuery({
    queryKey: ['shelf', status ?? 'all'],
    queryFn: () => libraryApi.listMyShelf(status),
  });
}
